export default __webpack_public_path__ + "static/media/eye.d8e18f85.svg";